import { PageLink } from '../../../../_metronic/layout/core'
import { ROLE } from '../../auth'
import { PayoutAmountMode, ReportOutcome } from './types'

/**
 * Значения укрупнённого фильтра исхода (CPAYMENT-1843) — общие для всех трёх отчётов.
 *
 * `CANCELLED` — псевдостатус фильтра, своего статуса у него нет: бэкенд разворачивает его в
 * DECLINED, а в отчёте по пополнениям ещё и в EXPIRED. Фактический статус строки отчёта при этом
 * не подменяется — просроченный депозит так и остаётся просроченным.
 */
export const REPORT_OUTCOME_OPTIONS: Array<{ value: ReportOutcome; label: string }> = [
  { value: 'COMPLETED', label: 'Завершён' },
  { value: 'CANCELLED', label: 'Отменён' },
]

/** Режим суммы по умолчанию — фактическая, как отчёт считал до появления переключателя. */
export const DEFAULT_PAYOUT_AMOUNT_MODE: PayoutAmountMode = 'ACTUAL'

export const PAYOUT_AMOUNT_MODE_OPTIONS: Array<{ value: PayoutAmountMode; label: string }> = [
  { value: 'ACTUAL', label: 'Сумма оплаты' },
  { value: 'REQUESTED', label: 'Сумма запроса' },
]

/**
 * Роли отчёта по выплатам мэтчинга (CPAYMENT-1760). Уже соседней payout-тройки: кассир и старший
 * кассир отчёт не видят — объём в нём атрибутирован владельцу депозитного чанка, а не кассе.
 * На бэкенде тот же список стоит на самих ручках `/api/reports/tickets/matching-payout/*`
 * (`ReportsController::MATCHING_PAYOUT_ACCESS`) — правишь здесь, правь и там.
 */
export const MATCHING_PAYOUT_REPORT_ROLES = [
  ROLE.ROLE_ADMIN,
  ROLE.ROLE_MANAGER,
  ROLE.ROLE_SENIOR_OPERATOR,
  ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
  ROLE.ROLE_MERCHANT_MANAGER,
]

export const MATCHING_PAYOUT_BREADCRUMBS: Array<PageLink> = [
  {
    title: 'Отчёт по пополнениям',
    path: '/reports/payment',
    isSeparator: false,
    isActive: false,
    roles: MATCHING_PAYOUT_REPORT_ROLES,
  },
  {
    title: 'Отчёт по выплатам',
    path: '/reports/payout',
    isSeparator: false,
    isActive: false,
    roles: MATCHING_PAYOUT_REPORT_ROLES,
  },
  {
    title: 'Отчёт по выплатам мэтчинга',
    path: '/reports/matching-payout',
    isSeparator: false,
    isActive: true,
    roles: MATCHING_PAYOUT_REPORT_ROLES,
  },
]
